var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgChatbotMenu = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 3,
    height: 12,
    viewBox: "0 0 3 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 7.5C1.10218 7.5 0.720645 7.34196 0.43934 7.06066C0.158036 6.77936 0 6.39782 0 6C0 5.60218 0.158036 5.22064 0.43934 4.93934C0.720645 4.65804 1.10218 4.5 1.5 4.5C1.89782 4.5 2.27936 4.65804 2.56066 4.93934C2.84196 5.22064 3 5.60218 3 6C3 6.39782 2.84196 6.77936 2.56066 7.06066C2.27936 7.34196 1.89782 7.5 1.5 7.5ZM1.5 3C1.10218 3 0.720645 2.84196 0.43934 2.56066C0.158036 2.27936 0 1.89782 0 1.5C0 1.10218 0.158036 0.720644 0.43934 0.43934C0.720645 0.158035 1.10218 0 1.5 0C1.89782 0 2.27936 0.158035 2.56066 0.43934C2.84196 0.720644 3 1.10218 3 1.5C3 1.89782 2.84196 2.27936 2.56066 2.56066C2.27936 2.84196 1.89782 3 1.5 3ZM1.5 12C1.10218 12 0.720645 11.842 0.43934 11.5607C0.158036 11.2794 0 10.8978 0 10.5C0 10.1022 0.158036 9.72064 0.43934 9.43934C0.720645 9.15804 1.10218 9 1.5 9C1.89782 9 2.27936 9.15804 2.56066 9.43934C2.84196 9.72064 3 10.1022 3 10.5C3 10.8978 2.84196 11.2794 2.56066 11.5607C2.27936 11.842 1.89782 12 1.5 12Z",
    fill: "#5B5A73"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgChatbotMenu);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Chatbot_menu.aa95283427009d91a7823f266d2a1619.svg";